import React, { useEffect, useState } from "react";
import "./styling/Preloader.css";

const SEEN_KEY = "orecasting_preloaded";

const prefersReducedMotion =
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * Preloader — a brief branded intro overlay shown on the first visit of a
 * browser session. The Orecasting wordmark animates in over a short progress
 * sweep, then the whole overlay wipes upward to reveal the hero (also masking
 * the moment while the WebGL scene and fonts finish loading).
 *
 * Shows once per tab session (sessionStorage) and is skipped entirely for
 * `prefers-reduced-motion` users.
 */
export default function Preloader() {
  const [render, setRender] = useState(() => {
    if (prefersReducedMotion) return false;
    try {
      return sessionStorage.getItem(SEEN_KEY) !== "1";
    } catch (e) {
      return true;
    }
  });
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!render) return undefined;
    try {
      sessionStorage.setItem(SEEN_KEY, "1");
    } catch (e) {
      /* private mode — ignore */
    }
    const toLeave = setTimeout(() => setLeaving(true), 1500);
    const toRemove = setTimeout(() => setRender(false), 2250);
    return () => {
      clearTimeout(toLeave);
      clearTimeout(toRemove);
    };
  }, [render]);

  if (!render) return null;

  return (
    <div className={`preloader${leaving ? " is-leaving" : ""}`} aria-hidden="true">
      <div className="preloader__inner">
        <span className="preloader__mark" />
        <span className="preloader__brand">Orecasting</span>
        <span className="preloader__bar">
          <span className="preloader__bar-fill" />
        </span>
      </div>
    </div>
  );
}
